module.exports = __webpack_public_path__ + "static/Messages_mobile_wbkg_3x-fb317795a7dfae0806d2f03c8293d736.png";